<template>
  <div>
    <div class="header-gnb hd-pooqzone">
      <h1 class="logo">
        <a @click.prevent="moveUrl('home')" href="#">
          <img src="../../../assets/images/wavvezone/logo.svg" alt="Wavve on logo" />
        </a>
      </h1>
      <nav class="gnb-left">
        <ul>
          <li>
            <a @click.prevent="moveUrl('home')" :class="isActive('home')">홈</a>
          </li>
          <li class="category-list-item" @focusin="focus()" @mouseenter.prevent="focus()" @mouseleave.prevent="blur()" >
            <button type="button" tabindex="0" data-gnb="category-menu">카테고리</button>
            <category-menu></category-menu>
            <category-menu-layer></category-menu-layer>
          </li>
          <li>
            <a @click.prevent="moveUrl('live')" href="#" :class="isActive('live')">LIVE</a>
          </li>
        </ul>
      </nav>
      <div :class="[
        'search-box',
        {'active' : isSearchBoxOpen},
        {'result': isSearchBoxAlwaysOpen}
       ]">
        <label for="search" type="button" class="btn-search" tabindex="0">
          <span class="a11y-hidden">검색</span>
        </label>
        <input
          type="text"
          @keyup="getSearchKeyword($event)"
          @focus.self.prevent="goSearchRouter"
          @keydown.enter="enterSearchKeyword($event)"
          class="search-inpt"
          id="search"
          name="search"
          placeholder="제목, 장르, 배우로 찾아보세요"
          ref="searchInput"
        >
        <button
          type="button"
          class="btn-del"
          @click.prevent="deleteSearchKeyword()"
        >
          <span class="a11y-hidden">검색어 삭제</span>
        </button>
      </div>
    </div>
    <SearchPopup
      v-if="showSearchPop"
      id="searchPop"
      :closeSearchPopup="closeSearchPopup"
      :search-page-type="searchPageType"
    />
  </div>
</template>

<script>
import SearchPopup from '@/components/search/view/SearchPopup'
import { removePrefixEmptyString, setDisableScrolling, setSearchWordSave } from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
import { mapGetters } from 'vuex'
import CategoryMenu from '@/components/common/header/CategoryMenu'
import CategoryMenuLayer from '@/components/common/header/CategoryMenuLayer'
import { SEARCH_AGAIN_INPUT_FOCUS, SEARCH_INPUT_FOCUS, SEARCH_RESULT_QUERY, SEARCH_TYPING_QUERY } from '@/common/resources/const'
import _ from 'lodash'
import { PATH_NAME_SEARCH } from '@/common/resources/router.const'

export default {
  components: {
    SearchPopup,
    CategoryMenu,
    CategoryMenuLayer
  },
  props: {
    isplayymovie: {
      type: String,
      default: 'y'
    }
  },
  data () {
    return {
      isVod: false,
      isMovie: false,
      showSearchPop: false,
      searchPageType: 'broadcast',
      pooqzoneType: cookie.getPooqZoneType(),
      isSearchBoxOpen: false,
      isSearchBoxAlwaysOpen: false
    }
  },
  methods: {
    showSearchPopup (type) {
      this.$events.$emit('setInputShow', false)
      if (typeof window.setInputShow === 'function') {
        window.setInputShow(false)
      }
      this.searchPageType = type
      this.showSearchPop = true
      setDisableScrolling(true) // 윈도우 스크롤 방지
    },
    closeSearchPopup () {
      this.showSearchPop = false
      setDisableScrolling(false) // 윈도우 스크롤 사용
    },
    moveUrl (gnb) {
      this.$router.push({ name: gnb })
    },
    isActive (menu) {
      return this.currentMenu === menu ? 'on' : ''
    },
    focus () {
      document.querySelector('.category-list-item').classList.add('on')
    },
    blur () {
      document.querySelector('.category-list-item').classList.remove('on')
    },
    keyup (e) {
      if (e.target.dataset.gnb !== 'category-menu') {
        document.querySelector('.category-list-item').classList.remove('on')
      }
    },
    goSearchRouter () {
      const CURRENT_URL_NAME = _.get(this.$route, 'name', '')
      const IS_DIFFERENT_ROUTE_LOCATION = (CURRENT_URL_NAME !== PATH_NAME_SEARCH)
      this.$events.$emit(SEARCH_AGAIN_INPUT_FOCUS, { isAutoCompleteReady: true })
      if (IS_DIFFERENT_ROUTE_LOCATION) {
        this.$router.push({
          name: PATH_NAME_SEARCH
        })
      }
    },
    getSearchKeyword: _.debounce(function (event) { this.sendSearchKeyword(event) }, 400),
    sendSearchKeyword (event) {
      this.$events.$emit(SEARCH_TYPING_QUERY, event.target.value)
    },
    deleteSearchKeyword () {
      const KEYWORD_INITIALIZED = ''
      this.$events.$emit(SEARCH_TYPING_QUERY, KEYWORD_INITIALIZED)
      this.$events.$emit(SEARCH_RESULT_QUERY, KEYWORD_INITIALIZED)
      this.$refs.searchInput.value = KEYWORD_INITIALIZED
      this.$router.push({
        name: PATH_NAME_SEARCH
      })
    },
    enterSearchKeyword (event) {
      const keyword = removePrefixEmptyString(event.target.value)
      const query = _.get(this.$route, ['query', 'searchWord'], '')
      if (keyword.length === 0) { alert('검색어를 입력 하세요.'); return false }
      setSearchWordSave(keyword)
      if (query !== keyword) {
        this.$events.$emit(SEARCH_RESULT_QUERY, keyword)
        this.$events.$emit(SEARCH_TYPING_QUERY, '')
        this.$router.push({
          name: PATH_NAME_SEARCH,
          query: { searchWord: keyword }
        })
      }
    },
    checkQuery () {
      const query = _.get(this.$route, ['query', 'searchWord'], '')
      const CLICK_KEYWORD_DELETE = (this.$route.name === PATH_NAME_SEARCH)
      if (query) {
        this.isSearchBoxAlwaysOpen = true
        this.$refs.searchInput.value = query
        this.$events.$emit(SEARCH_RESULT_QUERY, query)
      }
      if (CLICK_KEYWORD_DELETE) {
        this.isSearchBoxAlwaysOpen = true
      }
    }
  },
  mounted () {
    document.addEventListener('keyup', this.keyup)
    this.$events.$on(SEARCH_INPUT_FOCUS, () => {
      this.$refs.searchInput.focus()
    })
    this.checkQuery()
  },
  computed: {
    ...mapGetters(['currentMenu'])
  },
  created () {
    // 이벤트 리스너 설정
    this.$events.$on('showSearchPopupTag', value => {
      this.showSearchPopup(value)
    })
  },
  beforeDestroy () {
    this.$events.$off('showSearchPopup')
    document.removeEventListener('keyup', this.keyup)
    this.$events.$off(SEARCH_INPUT_FOCUS)
  }
}
</script>
